export { compile as jsonToTypescript } from 'json-schema-to-typescript';
export type { JSONSchema4 as JSONObject4 } from 'json-schema';
export type { JSONSchema4 } from 'json-schema';
